/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_InInputs */

const th_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังเข้าสู่ระบบ…`)
};

const en_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in…`)
};

const ja_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログインしています…`)
};

const zh_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在登录…`)
};

const es_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando sesión…`)
};

const pt_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrando…`)
};

const id_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk…`)
};

const fr_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion…`)
};

const tl_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagsi-sign in…`)
};

const vi_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang đăng nhập…`)
};

const ko_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 중…`)
};

const de_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird angemeldet…`)
};

const ru_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Входим…`)
};

const tr_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş yapılıyor…`)
};

const it_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso in corso…`)
};

const pl_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logowanie…`)
};

const uk_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Входимо…`)
};

const hi_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साइन इन हो रहा है…`)
};

const ar_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تسجيل الدخول…`)
};

const ms_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang log masuk…`)
};

const bn_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাইন ইন হচ্ছে…`)
};

const zh_tw2_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入中…`)
};

const zh_hk2_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入中…`)
};

const ur_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سائن اِن ہو رہا ہے…`)
};

const fa_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال ورود…`)
};

const sw_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaingia…`)
};

const nl_signing_in = /** @type {(inputs: Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met inloggen…`)
};

/**
* | output |
* | --- |
* | "Signing in…" |
*
* @param {Signing_InInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const signing_in = /** @type {((inputs?: Signing_InInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_InInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_signing_in(inputs)
	if (locale === "ja") return ja_signing_in(inputs)
	if (locale === "zh") return zh_signing_in(inputs)
	if (locale === "es") return es_signing_in(inputs)
	if (locale === "pt") return pt_signing_in(inputs)
	if (locale === "id") return id_signing_in(inputs)
	if (locale === "fr") return fr_signing_in(inputs)
	if (locale === "tl") return tl_signing_in(inputs)
	if (locale === "vi") return vi_signing_in(inputs)
	if (locale === "ko") return ko_signing_in(inputs)
	if (locale === "de") return de_signing_in(inputs)
	if (locale === "ru") return ru_signing_in(inputs)
	if (locale === "tr") return tr_signing_in(inputs)
	if (locale === "it") return it_signing_in(inputs)
	if (locale === "pl") return pl_signing_in(inputs)
	if (locale === "uk") return uk_signing_in(inputs)
	if (locale === "hi") return hi_signing_in(inputs)
	if (locale === "ar") return ar_signing_in(inputs)
	if (locale === "ms") return ms_signing_in(inputs)
	if (locale === "bn") return bn_signing_in(inputs)
	if (locale === "zh-TW") return zh_tw2_signing_in(inputs)
	if (locale === "zh-HK") return zh_hk2_signing_in(inputs)
	if (locale === "ur") return ur_signing_in(inputs)
	if (locale === "fa") return fa_signing_in(inputs)
	if (locale === "sw") return sw_signing_in(inputs)
	if (locale === "nl") return nl_signing_in(inputs)
	return en_signing_in(inputs)
});